import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'chart-summary',
});

export const featureDetailsRouteRef = createSubRouteRef({
  id: 'chart-summary/feature-detail',
  parent: rootRouteRef,
  path: '/feature/:feature_id',
});

export const applicationDetailsRouteRef = createSubRouteRef({
  id: 'chart-summary/application-detail',
  parent: rootRouteRef,
  path: '/application/:application_id',
});
